export const FILE_UPLOAD_SIZE = 30;
export const IF_SUBMISSION_FILE_UPLOAD_SIZE_LIMIT = 10;
export const FILE_TYPE_CSV = 'text/csv';
export const FILE_TYPE_PDF = 'application/pdf';

export enum Product {
  SETTLEMENT_FINANCE = 'SF',
  INVESTMENT_FINANCE = 'IF',
}

export enum DocumentTypes {
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  INVOICE = 'INVOICE',
  GOODS_RECEIPT = 'GOODS_RECEIPT',
}

export enum EDocumentStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
}

export enum BlockTypes {
  OVERDUE_LOANS_PAST_ALLOWED_MAX_DPD = 'OVERDUE_LOANS_PAST_ALLOWED_MAX_DPD',
}
